import React from 'react';
import { prettifyUtcDateTimeHHmm } from 'odfjell-date-time-utils/dateTimeFormatter';

import { useVerificationStore } from '../../context/VerificationContext';

import { VerificationDetails } from '../../pages/verification/Verification.styles';
import { DNVReportType } from '../../enums/dnvReportTypeEnum';
import VerificationStatusText from '../ui/status-icon/VerificationStatusText';
import { getReportTypeString } from '../../utils/verification/verificationUtils';
import ReprocessReportButton from './ReprocessReportButton';

export enum tabEnum {
    details = 1,
    verification = 2,
}

const VerificationDetailsComponent: React.FC = () => {
    const { selectedReportMetadata } = useVerificationStore();

    return (
        <>
            {selectedReportMetadata && (
                <VerificationDetails>
                    <div className="field">
                        <label>Status</label>
                        <span>{VerificationStatusText(selectedReportMetadata.status)}</span>
                    </div>
                    <div className="field">
                        <label>Vessel</label>
                        <span>{selectedReportMetadata.vesselName}</span>
                    </div>
                    <div className="field">
                        <label>IMO number</label>
                        <span>{selectedReportMetadata.imoNumber}</span>
                    </div>
                    <div className="field">
                        <label>Type</label>
                        <span>{getReportTypeString(selectedReportMetadata.reportType)}</span>
                    </div>
                    {selectedReportMetadata.reportType === DNVReportType.OVDLA && (
                        <div className="field">
                            <label>Voyage number</label>
                            <span>{selectedReportMetadata.voyageNumber}</span>
                        </div>
                    )}
                    {selectedReportMetadata.reportType === DNVReportType.OVDBR && (
                        <div className="field">
                            <label>Bunkering number</label>
                            <span>{selectedReportMetadata.bunkeringNumber}</span>
                        </div>
                    )}
                    {selectedReportMetadata.voyageDateTimeUtcFrom && (
                        <div className="field">
                            <label>Period start (UTC)</label>
                            <span>{prettifyUtcDateTimeHHmm(selectedReportMetadata.voyageDateTimeUtcFrom)}</span>
                        </div>
                    )}
                    {selectedReportMetadata.voyageDateTimeUtcTo && (
                        <div className="field">
                            <label>Period end (UTC)</label>
                            <span>{prettifyUtcDateTimeHHmm(selectedReportMetadata.voyageDateTimeUtcTo)}</span>
                        </div>
                    )}
                    {selectedReportMetadata.portFrom && (
                        <div className="field">
                            <label>Port from</label>
                            <span>
                                {selectedReportMetadata.portFrom} ({selectedReportMetadata.portFromUnCode})
                            </span>
                        </div>
                    )}
                    {selectedReportMetadata.portTo && (
                        <div className="field">
                            <label>Port to</label>
                            <span>
                                {selectedReportMetadata.portTo} ({selectedReportMetadata.portToUnCode})
                            </span>
                        </div>
                    )}
                    <div className="field">
                        <label>Latest version</label>
                        <span>{selectedReportMetadata.latestReportVersion}</span>
                    </div>
                    <div className="field">
                        <label>Version sent to DNV</label>
                        <span>{selectedReportMetadata.reportVersionSentToDNV}</span>
                    </div>
                    <div className="field">
                        <label>Report last updated (UTC)</label>
                        <span>{prettifyUtcDateTimeHHmm(selectedReportMetadata.latestReportTimestamp)}</span>
                    </div>
                    <div className="field">
                        <label>Report sent to DNV (UTC)</label>
                        <span>{prettifyUtcDateTimeHHmm(selectedReportMetadata.sentToDNVAtTimestamp)}</span>
                    </div>
                    <div className="field">
                        <label>Report sent by</label>
                        <span>{selectedReportMetadata.lastSentByUser}</span>
                    </div>
                    <div className="field">
                        <label>Verification received (UTC)</label>
                        <span>{prettifyUtcDateTimeHHmm(selectedReportMetadata.maxVerificationDate)}</span>
                    </div>
                    <ReprocessReportButton />
                </VerificationDetails>
            )}
        </>
    );
};
export default VerificationDetailsComponent;
